export default class SessionStorageUtils {
  static setData(key, data) {
    const serializedData = JSON.stringify(data);
    sessionStorage.setItem(key, serializedData);
  }

  static getData(key, defaultValue = null) {
    const serializedData = sessionStorage.getItem(key);
    if (serializedData === null) {
      return defaultValue;
    }
    return JSON.parse(serializedData);
  }

  static removeData(key) {
    sessionStorage.removeItem(key);
  }

  static clearAll() {
    sessionStorage.clear();
  }

  static hasKey(key) {
    return sessionStorage.getItem(key) !== null;
  }

  static getAllKeys() {
    return Object.keys(sessionStorage);
  }
}
